var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowOnActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    x: 7.5,
    y: 8.5,
    fill: "#4092f5",
    stroke: "#4092f5",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    x: 7.5,
    y: 16.5,
    fill: "#4092f5",
    stroke: "#4092f5",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 12h2v1H8zM10 10h2v3h-2zM12 11h2v2h-2zM20 20h2v1h-2zM18 18h2v3h-2zM16 20h2v1h-2zM14 19h2v2h-2zM12 18h2v3h-2zM10 18h2v3h-2zM8 19h2v2H8zM14 10h2v3h-2zM16 12h2v1h-2zM18 11h2v2h-2zM20 11h2v2h-2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowOnActive);
export default __webpack_public_path__ + "static/media/low-on-active.c2bd17da9c1e1c57e111677926c4537a.svg";
export { ForwardRef as ReactComponent };